/* PetSnack thema: winkelmand-drawer via de Shopify AJAX-API, nav-drawer, ticker,
   USP-strook, footer-accordion, filters op de collectiepagina, PDP. */
(function () {
  var cfg = window.PetSnack || {};
  function euro(cents) {
    var f = cfg.moneyFormat || "€{{amount_with_comma_separator}}";
    var n = cents / 100, s;
    if (f.indexOf("comma_separator") >= 0) s = n.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    else s = n.toFixed(2);
    return f.replace(/\{\{.*?\}\}/, s).replace(/<[^>]+>/g, "").replace("€", "€ ");
  }
  function toast(t) {
    var el = document.getElementById("toast"); if (!el) return;
    el.textContent = t; el.classList.add("aan");
    clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove("aan"); }, 1800);
  }

  /* ---------- winkelmand (naar het Karperloco-mandje, 01-10-2026) ----------
     Strook, items, rij "Vaak samen besteld" met pijlen, beloningsladder, regels en
     totaal. De tredes komen uit de data-attributen van #drawer-ladder (thema-
     instellingen Winkelmand): gratis verzending en twee kortingstredes. Bedragen
     in de ladder zijn euro's, bedragen uit cart.js centen. */
  var IC = {
    minimum: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1.2 11H6.2z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>',
    verzending: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>',
    cadeau: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 11.5h16V20H4z"/><path d="M3 7.5h18v4H3z"/><path d="M12 7.5V20"/><path d="M12 7.5c-1.3-3.2-5.2-3.4-4.6-1.2.4 1.4 3 1.2 4.6 1.2zm0 0c1.3-3.2 5.2-3.4 4.6-1.2-.4 1.4-3 1.2-4.6 1.2z"/></svg>',
    korting: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M19 5 5 19"/><circle cx="7.5" cy="7.5" r="2.2"/><circle cx="16.5" cy="16.5" r="2.2"/></svg>',
    vink: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>'
  };
  function getal(x) { return parseFloat(String(x || 0).replace(",", ".")) || 0; }
  function laag(x) { return x.charAt(0).toLowerCase() + x.slice(1); }
  var mandSub = 0, pdpReken = null;   /* bestelbedrag zonder cadeaus, en de PDP-herberekening (spaarladder) */
  /* Cadeautrede (8 oktober 2026): alleen met drempel en product. Rutger: snack op de ene trede,
     op de andere een verrassingscadeau waarvan de inhoud wisselt (klant ziet niet wat). */
  function cadeauTrede(lad, nr) {
    var k = "cadeau" + (nr || ""), d = getal(lad.dataset[k]), v = lad.dataset[k + "Variant"] || "";
    if (!(d > 0) || !v) return null;
    var naam = (lad.dataset[k + "Naam"] || "Cadeau").trim() || "Cadeau";
    return { bedrag: d, soort: "cadeau", variant: String(v), handle: lad.dataset[k + "Handle"] || "", naast: "je " + laag(naam), binnen: "je " + laag(naam), label: naam, kort: naam };
  }
  /* Tredes: per trede het bedrag, de soort (icoon), "naast" voor de zin "Nog € x tot ...",
     "binnen" voor de zin als alles gehaald is en "kort" voor het label onder de trede. */
  function tredes(lad) {
    var t = [], g = getal(lad.dataset.gratis), d1 = getal(lad.dataset.d1), k1 = getal(lad.dataset.k1), d2 = getal(lad.dataset.d2), k2 = getal(lad.dataset.k2);
    if (g > 0) t.push({ bedrag: g, soort: "verzending", naast: "gratis verzending", binnen: "gratis verzending", label: "Gratis verzending", kort: "Gratis verzending" });
    /* 27 oktober 2026 (Rutger: "25 EUR minimal order value als stapje"): eerste trede, zelfde bedrag als het minimum in Shopify. Telt niet mee in "alles binnen" en schakelt Afrekenen uit zolang de mand eronder zit. */
    var mn = getal(lad.dataset.minimum);
    if (mn > 0) t.push({ bedrag: mn, soort: "minimum", naast: "het minimum bestelbedrag", hiermee: "bestellen mogelijk", binnen: "", label: "Minimum bestelbedrag", kort: "Minimum" });   /* label op één regel, anders valt hij over de lijn eronder (Rutger 27-10) */
    var c1 = cadeauTrede(lad, ""), c2 = cadeauTrede(lad, "2");
    if (c1) t.push(c1);
    if (c2) t.push(c2);
    if (d1 > 0 && k1 > 0) t.push({ bedrag: d1, soort: "korting", naast: k1 + "% korting op alles", binnen: k1 + "% korting op alles", label: k1 + "% korting", kort: k1 + "% korting" });
    if (d1 > 0 && k1 > 0 && d2 > d1 && k2 > k1) t.push({ bedrag: d2, soort: "korting", naast: k2 + "% korting op alles", binnen: k2 + "% korting op alles", label: k2 + "% korting", kort: k2 + "% korting" });
    t.sort(function (a, b) { return a.bedrag - b.bedrag; });
    return t;
  }
  function isCadeau(t, i) {
    var v = String(i.variant_id);
    for (var k = 0; k < t.length; k++) if (t[k].variant === v) return true;
    return !!(i.properties && i.properties._cadeau);
  }
  function mandBedrag(t, cart) {   /* bestelbedrag zonder cadeaus, in euro's */
    var c = 0; cart.items.forEach(function (i) { if (!isCadeau(t, i)) c += (i.final_line_price != null ? i.final_line_price : i.line_price) || 0; });
    return c / 100;
  }
  /* bundels in de mand (8 oktober 2026): groepssleutel per regel, kop en totaal van een groep, open/dicht-stand per sleutel */
  var GROEP = "Abonnement op maat", openBundels = {};
  function esc(x) { return String(x == null ? "" : x).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }
  function groepVan(i) { var p = i.properties || {}; return String(p._groep || p[GROEP] || ""); }
  function bundelKop(items) {
    var p = items[0].properties || {}, n = 0, cents = 0, plan = "";
    items.forEach(function (i) { n += i.quantity; cents += (i.original_line_price != null ? i.original_line_price : i.line_price) || 0; if (!plan && i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) plan = i.selling_plan_allocation.selling_plan.name || ""; });
    var zakken = n + (n === 1 ? " zak" : " zakken"), naam, maat;
    if (p[GROEP]) {   /* abonnementbouwer: "De doos van Max · elke 4 weken" */
      var delen = String(p[GROEP]).split(" · "); naam = delen.shift(); maat = GROEP + " · " + zakken + (delen.length ? " · " + delen.join(" · ") : "");
    } else { naam = p["Eigen bundel"] ? "Eigen bundel" : "Bundel"; maat = zakken + (plan ? " · abonnement, " + laag(plan) : " · zelf samengesteld"); }
    return { naam: naam, maat: maat, n: n, cents: cents };
  }
  function volgende(t, sub) { for (var i = 0; i < t.length; i++) if (sub < t[i].bedrag - 0.005) return t[i]; return null; }
  /* De balk (8 oktober 2026, Rutger: "kan je dit beter maken?"): de tredes staan op gelijke
     afstand van elkaar, niet naar bedrag, zodat er onder elk punt ruimte is voor het bedrag en
     de beloning. De vulling loopt per stuk lineair (van de vorige trede naar de volgende). De
     eerstvolgende trede krijgt een klei-rand, een gehaalde trede wordt bos met een vinkje. */
  function ladder(t, sub) {
    if (!t.length) return "";
    var n = t.length, vg = volgende(t, sub), tekst;
    if (vg) tekst = "Nog <b>" + euro(Math.round((vg.bedrag - sub) * 100)) + "</b> tot " + vg.naast + ".";
    else {
      var delen = [], hoogsteKorting = null;
      t.forEach(function (d) { if (d.soort === "minimum") return; if (d.soort === "korting") hoogsteKorting = d; else delen.push(d.binnen); });
      if (hoogsteKorting) delen.push(hoogsteKorting.binnen);
      if (!delen.length) tekst = "Je kunt bestellen.";
      else if (delen.length === 1) tekst = delen[0] + " is binnen.";
      else tekst = "Alles binnen: " + delen.slice(0, -1).join(", ") + " en " + delen[delen.length - 1] + ".";
      tekst = tekst.charAt(0).toUpperCase() + tekst.slice(1);
    }
    var vul = 1;
    for (var i = 0; i < n; i++) {
      var van = i ? t[i - 1].bedrag : 0, tot = t[i].bedrag;
      if (sub < tot - 0.005) { vul = (i + Math.max(0, sub - van) / Math.max(0.01, tot - van)) / n; break; }
    }
    var punten = t.map(function (d, i) {
      var aan = sub >= d.bedrag - 0.005, pos = (i + 1) / n * 100, bedrag = euro(Math.round(d.bedrag * 100)).replace(",00", "");
      return '<span class="punt' + (aan ? " aan" : d === vg ? " volgende" : "") + '" style="left:' + pos + '%" title="' + d.label + ' vanaf ' + bedrag + '">' +
        '<i>' + IC[d.soort] + '</i><small><b>' + bedrag + '</b>' + d.kort + '</small></span>';
    }).join("");
    return '<p class="tekst">' + tekst + '</p><div class="baan"><div class="vul" style="width:' + (vul * 100) + '%"></div>' + punten + '</div>';
  }
  function teken(cart) {
    var lad = document.getElementById("drawer-ladder"), t = lad ? tredes(lad) : [];
    /* 8 oktober 2026 (Rutger: "dat het er uit ziet als een bundel in de cart, en dat iemand in de drawer de bundel kan
       openklappen om te zien wat er allemaal in zit"): regels uit Stel zelf samen (eigenschap _groep) en uit de
       abonnementbouwer (eigenschap "Abonnement op maat") horen bij elkaar. Ze staan als één ingeklapte bundelregel in de
       mand en tellen als één in de badge; openklappen toont de zakken met hun eigen stepper. */
    var blokken = [], perGroep = {};
    cart.items.forEach(function (i, idx) {
      var g = isCadeau(t, i) ? "" : groepVan(i);
      if (!g) { blokken.push({ item: i, idx: idx }); return; }
      if (!perGroep[g]) { perGroep[g] = { sleutel: g, regels: [] }; blokken.push(perGroep[g]); }
      perGroep[g].regels.push({ item: i, idx: idx });
    });
    var telling = 0; blokken.forEach(function (b) { if (b.regels) telling += 1; else if (!isCadeau(t, b.item)) telling += b.item.quantity; });
    document.querySelectorAll(".badge").forEach(function (b) { b.textContent = telling; b.hidden = !telling; });
    var sub = mandBedrag(t, cart);
    mandSub = sub; if (pdpReken) pdpReken();
    var lijst = document.getElementById("drawer-items"); if (!lijst) return;
    var leeg = !cart.items.length;
    var leegEl = document.getElementById("drawer-leeg"); if (leegEl) leegEl.hidden = !leeg;
    lijst.hidden = leeg && !!leegEl;
    /* oude drawer-markup (zonder #drawer-leeg): toon de oude lege tekst en de oude verzendregel */
    var vzOud = document.getElementById("drawer-verzend");
    if (vzOud) { var gratisOud = getal(vzOud.dataset.gratis || 50) * 100; vzOud.textContent = cart.total_price >= gratisOud ? "Gratis verzending" : "Nog " + euro(gratisOud - cart.total_price) + " tot gratis verzending"; }
    function regel(i, idx, inBundel) {
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?.*)?$/i, "_144x144$1") : "";
      var maat = (i.variant_title || "").replace(/ \| /g, ", ");
      /* 27 oktober 2026 (Rutger: mand te druk op mobiel): maat weglaten als die al in de productnaam staat ("Buffelslurf 12 cm 250-300 gram"). */
      if (maat && (i.product_title || "").toLowerCase().indexOf(maat.replace(/,/g, "").toLowerCase()) > -1) maat = "";
      if (isCadeau(t, i)) return '<div class="drawer-item cadeau">' + (img ? '<span class="foto"><img src="' + img + '" alt="" width="72" height="72"></span>' : '<span class="cadeau-beeld">' + IC.cadeau + '</span>') +
        '<div class="info"><div class="naam">' + i.product_title + '</div><div class="maat">Cadeau bij je bestelling</div><div class="aantal"><b class="gratis">' + (i.final_line_price > 0 ? euro(i.final_line_price) : "Gratis") + '</b></div></div><span class="cadeau-tag">' + IC.cadeau + '</span></div>';
      return '<div class="drawer-item' + (inBundel ? ' in-bundel' : '') + '">' + (img ? '<span class="foto"><img src="' + img + '" alt="" width="72" height="72"></span>' : "") +
        '<div class="info"><div class="naam"><a href="' + i.url + '">' + i.product_title + '</a></div>' + (maat ? '<div class="maat">' + maat + '</div>' : "") +
        '<div class="aantal"><b>' + i.quantity + ' × ' + euro(i.original_price || i.price) + '</b> <button type="button" class="verwijder" onclick="cartChange(' + (idx + 1) + ',0)">verwijder</button></div></div>' +
        '<div class="stepper klein"><button onclick="cartChange(' + (idx + 1) + ',' + (i.quantity - 1) + ')" aria-label="minder">−</button><input value="' + i.quantity + '" readonly><button onclick="cartChange(' + (idx + 1) + ',' + (i.quantity + 1) + ')" aria-label="meer">+</button></div></div>';
    }
    function bundel(b) {
      var k = bundelKop(b.regels.map(function (r) { return r.item; }));
      var beelden = b.regels.slice(0, 4).map(function (r) { var im = r.item.image ? r.item.image.replace(/(\.[a-z]+)(\?.*)?$/i, "_144x144$1") : ""; return im ? '<img src="' + im + '" alt="" width="34" height="34">' : "<i></i>"; }).join("");
      return '<details class="drawer-bundel"' + (openBundels[b.sleutel] ? " open" : "") + ' data-groep="' + esc(b.sleutel) + '"><summary>' +
        '<span class="bb-beeld n' + Math.min(4, b.regels.length) + '">' + beelden + '</span>' +
        '<div class="info"><div class="naam">' + esc(k.naam) + '</div><div class="maat">' + esc(k.maat) + '</div>' +
        '<div class="aantal"><b>' + euro(k.cents) + '</b> <button type="button" class="verwijder" onclick="event.preventDefault();event.stopPropagation();cartRemoveGroup(this)">verwijder</button></div></div>' +
        /* 28 oktober 2026 (Rutger: "bij een eigen bundel moet een 1 staan en kan hij er 2 van maken, zoals bij ieder ander product"): plus/min op de
           bundelregel. Het aantal is de grootste gemene deler van de zakken (2 Nekspier + 2 Grills = bundel x2); plus/min schaalt alle regels mee. */
        '<div class="stepper klein bb-stepper"><button type="button" onclick="event.preventDefault();event.stopPropagation();cartScaleGroup(this,-1)" aria-label="minder">−</button><input value="' + bundelAantal(b.regels.map(function (r) { return r.item; })) + '" readonly><button type="button" onclick="event.preventDefault();event.stopPropagation();cartScaleGroup(this,1)" aria-label="meer">+</button></div>' +
        '<span class="bb-klap" aria-hidden="true"><small>' + b.regels.length + ' soort' + (b.regels.length === 1 ? "" : "en") + '</small><i></i></span></summary>' +
        '<div class="bb-inhoud">' + b.regels.map(function (r) { return regel(r.item, r.idx, true); }).join("") + '</div></details>';
    }
    lijst.innerHTML = leeg && !leegEl ? '<div class="leeg">Je winkelmand is nog leeg.</div>' : blokken.map(function (b) { return b.regels ? bundel(b) : regel(b.item, b.idx, false); }).join("");
    lijst.querySelectorAll("details.drawer-bundel").forEach(function (d) { d.addEventListener("toggle", function () { openBundels[d.dataset.groep] = d.open; }); });
    var strook = document.getElementById("drawer-strook"); if (strook) strook.hidden = leeg;
    if (lad) { lad.innerHTML = ladder(t, sub); lad.hidden = leeg || !t.length; }
    var voet = document.getElementById("drawer-voet"), tarief = voet ? getal(voet.dataset.verzend) : 0;
    var gratisTrede = t.filter(function (d) { return d.soort === "verzending"; })[0];
    var gratis = gratisTrede ? sub >= gratisTrede.bedrag - 0.005 : false;
    var verzend = !leeg && !gratis && tarief > 0 ? Math.round(tarief * 100) : 0;
    var regels = document.getElementById("drawer-regels");
    if (regels) {
      var kortingNaam = (cart.cart_level_discount_applications || []).map(function (d) { return d.title; }).join(", ") || "Korting";
      /* cadeaus met een prijs die Shopify wegstreept (Koop X krijg Y) staan als eigen regel "Cadeau" */
      var cadeauKort = 0; cart.items.forEach(function (i) { if (isCadeau(t, i)) cadeauKort += Math.max(0, (i.original_line_price || 0) - (i.final_line_price || 0)); });
      var kort = Math.max(0, (cart.total_discount || 0) - cadeauKort);
      /* subtotaal alleen als het verschilt van het totaal: bij korting of verzendkosten (Rutger 4 oktober 2026) */
      var metSub = kort > 0 || cadeauKort > 0 || verzend > 0;
      regels.innerHTML = leeg ? "" : (metSub ? '<div><span>Subtotaal</span><span>' + euro(cart.items_subtotal_price) + '</span></div>' : "") +
        (kort > 0 ? '<div class="goed"><span>' + kortingNaam + '</span><span>−' + euro(kort) + '</span></div>' : "") +
        (cadeauKort > 0 ? '<div class="goed"><span>Cadeau</span><span>−' + euro(cadeauKort) + '</span></div>' : "") +
        (gratisTrede || tarief > 0 ? '<div' + (gratis ? ' class="goed"' : "") + '><span>Verzending</span><span>' + (gratis ? "Gratis" : (verzend ? euro(verzend) : "bij afrekenen")) + '</span></div>' : "");
    }
    if (voet) voet.hidden = leeg;
    var afr = document.getElementById("drawer-afrekenen"), mnT = t.filter(function (d) { return d.soort === "minimum"; })[0], onderMin = !!(mnT && sub < mnT.bedrag - 0.005);
    if (afr) { afr.classList.toggle("uit", onderMin); afr.setAttribute("aria-disabled", onderMin ? "true" : "false"); afr.textContent = onderMin ? "Bestellen vanaf " + euro(Math.round(mnT.bedrag * 100)).replace(",00", "") : "Afrekenen"; }
    var tot = document.getElementById("drawer-totaal"); if (tot) tot.textContent = euro(cart.total_price + verzend);
    upsellTeken(cart, t, sub);
    cadeauSync(cart, t, sub);
  }
  /* Cadeaus in en uit de mand (8 oktober 2026). Per ronde één handeling (regelnummers schuiven),
     daarna de mand opnieuw ophalen; teken() roept dit dan weer aan tot alles klopt. Mislukt
     toevoegen (bijvoorbeeld uitverkocht), dan niet blijven proberen. Hooguit 4 handelingen per
     paginabezoek, zodat een fout nooit een lus wordt. */
  var cadeauBezig = false, cadeauMislukt = {}, cadeauTeller = 0;
  function cadeauSync(cart, t, sub) {
    if (cadeauBezig || cadeauTeller >= 4) return;
    var actie = null;
    t.forEach(function (d) {
      if (actie || d.soort !== "cadeau" || !d.variant) return;
      var regels = [];
      cart.items.forEach(function (i, idx) { if (String(i.variant_id) === d.variant) regels.push({ line: idx + 1, q: i.quantity }); });
      var wil = sub >= d.bedrag - 0.005;
      if (wil && !regels.length) { if (!cadeauMislukt[d.variant]) actie = { add: d.variant }; }
      else if (!wil && regels.length) actie = { line: regels[0].line, q: 0 };
      else if (wil && (regels.length > 1 || regels[0].q !== 1)) actie = regels.length > 1 ? { line: regels[1].line, q: 0 } : { line: regels[0].line, q: 1 };
    });
    /* 27 oktober 2026 (Rutger: "ik was ingelogd op mijn mobiel en toen zag ik een cadeautje staan in het winkelkarretje"):
       een ingelogde klant krijgt zijn opgeslagen mand terug, ook met een cadeauregel van toen de trede nog aanstond.
       Een regel met eigenschap _cadeau waar geen (aan)trede meer bij hoort, gaat daarom ook weg. */
    if (!actie) cart.items.forEach(function (i, idx) {
      if (actie || !(i.properties && i.properties._cadeau)) return;
      var hoort = false; t.forEach(function (d) { if (d.soort === "cadeau" && d.variant === String(i.variant_id)) hoort = true; });
      if (!hoort) actie = { line: idx + 1, q: 0 };
    });
    if (!actie) return;
    cadeauBezig = true; cadeauTeller++;
    var kop = { "Content-Type": "application/json", "Accept": "application/json" }, p;
    if (actie.add) p = fetch((cfg.root || "/") + "cart/add.js", { method: "POST", credentials: "same-origin", headers: kop, body: JSON.stringify({ id: actie.add, quantity: 1, properties: { _cadeau: "1" } }) })
      .then(function (r) { if (!r.ok) { cadeauMislukt[actie.add] = 1; throw r; } });
    else p = fetch((cfg.root || "/") + "cart/change.js", { method: "POST", credentials: "same-origin", headers: kop, body: JSON.stringify({ line: actie.line, quantity: actie.q }) })
      .then(function (r) { if (!r.ok) throw r; });
    p.then(function () { cadeauBezig = false; return haalCart(); })
      .then(function () { if (document.body.classList.contains("template-cart")) location.reload(); })
      .catch(function () { cadeauBezig = false; });
  }
  /* Welke kaart dicht het gat naar de volgende trede (1 tot 3 stuks, niet te ver erover)? Die krijgt
     het label "Hiermee: ..." en schuift naar voren. Kaarten van producten die al in de mand liggen gaan weg. */
  function upsellTeken(cart, t, sub) {
    var up = document.getElementById("drawer-upsell"), rij = document.getElementById("drawer-upsell-rij"); if (!up || !rij) return;
    var inMand = {}; cart.items.forEach(function (i) { inMand[i.handle] = 1; });
    t.forEach(function (d) { if (d.handle) inMand[d.handle] = 1; });   /* cadeauproducten nooit als kaart */
    var vg = volgende(t, sub), gat = vg ? vg.bedrag - sub : 0, venster = Math.max(8, gat * 0.75);
    up.classList.toggle("alles-binnen", !vg);   /* 27 oktober 2026: op mobiel verbergt petsnack.css de rij zodra alle tredes binnen zijn */
    var over = 0, sluiters = [], rest = [];
    function zet(k, n, label) {
      var prijs = parseInt(k.dataset.prijs, 10) / 100;
      k.dataset.n = n; k.classList.toggle("sluiter", !!label);
      var em = k.querySelector("em"); if (em) { em.hidden = !label; em.textContent = label || ""; }
      var b = k.querySelector(".titel"); if (b) b.textContent = (n > 1 ? n + " × " : "") + k.dataset.naam;
      var s = k.querySelector("small"); if (s) s.textContent = (k.dataset.maat ? k.dataset.maat + " · " : "") + euro(Math.round(n * prijs * 100));
    }
    Array.prototype.slice.call(rij.querySelectorAll(".upsell-kaart")).forEach(function (k) {
      var al = !!inMand[k.dataset.handle]; k.hidden = al; if (al) return;
      over++;
      var prijs = parseInt(k.dataset.prijs, 10) / 100, n = 1, past = false;
      if (vg && prijs > 0) for (n = 1; n <= 3; n++) { if (n * prijs >= gat - 0.005) { past = n * prijs - gat <= venster; break; } }
      if (past) sluiters.push({ k: k, over: n * prijs - gat, n: n }); else rest.push({ k: k, n: 1 });
    });
    sluiters.sort(function (a, b) { return (a.over + (a.n - 1) * 1.5) - (b.over + (b.n - 1) * 1.5); });
    sluiters = sluiters.slice(0, 2).concat(sluiters.slice(2).map(function (x) { return { k: x.k, n: 1 }; })).concat(rest);
    sluiters.forEach(function (x, i) { zet(x.k, x.n, i < 2 && x.over !== undefined ? "Hiermee: " + (vg.hiermee || vg.naast) : ""); rij.appendChild(x.k); });
    sluiters = sluiters.filter(function (x) { return x.over !== undefined; });
    var kop = document.getElementById("drawer-upsell-kop"); if (kop) kop.textContent = sluiters.length ? "Maak je bestelling compleet" : "Vaak samen besteld";
    up.hidden = !cart.items.length || !over;
    rij.scrollLeft = 0;
  }
  function hop() {
    document.querySelectorAll(".iknop.cart").forEach(function (k) { k.classList.remove("hop"); void k.offsetWidth; k.classList.add("hop"); k.addEventListener("animationend", function () { k.classList.remove("hop"); }, { once: true }); });
  }
  function haalCart() { return fetch((cfg.root || "/") + "cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (c) { teken(c); return c; }); }
  window.cartAdd = function (id, aantal, plan) {
    var body = { id: id, quantity: Math.max(1, parseInt(aantal, 10) || 1) };
    if (plan) body.selling_plan = plan;   /* abonnement: selling plan uit Shopify Subscriptions */
    return fetch((cfg.root || "/") + "cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return haalCart(); }).then(function () { hop(); cartOpen(); })
      .catch(function () { toast("Toevoegen lukte niet. Probeer het nog eens."); });
  };
  /* meerdere regels in één keer (abonnement op maat), met selling plan en eigenschappen per regel */
  window.cartAddItems = function (items) {
    return fetch((cfg.root || "/") + "cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return haalCart(); }).then(function () { hop(); cartOpen(); });
  };
  window.cartChange = function (line, aantal) {
    return fetch((cfg.root || "/") + "cart/change.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ line: line, quantity: Math.max(0, aantal) }) })
      .then(function (r) { return r.json(); }).then(function (c) { teken(c); if (document.body.classList.contains("template-cart")) location.reload(); });
  };
  /* hele bundel weghalen (8 oktober 2026): regel voor regel op sleutel, van achter naar voren, daarna één keer tekenen */
  function ggd(a, b) { return b ? ggd(b, a % b) : a; }
  function bundelAantal(items) { return items.reduce(function (g, i) { return ggd(g, i.quantity); }, 0) || 1; }
  /* 28 oktober 2026: bundel x2, x3 … of terug; op 0 gaat de hele bundel weg (zie bundel() in teken). Per regel één cart/change.js, na elkaar. */
  window.cartScaleGroup = function (el, d) {
    var box = el && el.closest ? el.closest("[data-groep]") : null, g = box ? box.dataset.groep : "";
    if (!g) return;
    var kop = { "Content-Type": "application/json", "Accept": "application/json" };
    return fetch((cfg.root || "/") + "cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (c) {
      var regels = c.items.filter(function (i) { return groepVan(i) === g; }); if (!regels.length) return;
      var nu = bundelAantal(regels), straks = nu + d;
      if (straks <= 0) return cartRemoveGroup(el);
      return regels.reduce(function (p, i) {
        var nieuw = Math.max(1, Math.round(i.quantity / nu * straks));
        return p.then(function () { return fetch((cfg.root || "/") + "cart/change.js", { method: "POST", credentials: "same-origin", headers: kop, body: JSON.stringify({ id: i.key, quantity: nieuw }) }); });
      }, Promise.resolve()).then(function () { openBundels[g] = true; return haalCart(); }).then(function () { if (document.body.classList.contains("template-cart")) location.reload(); });
    });
  };
  window.cartRemoveGroup = function (el) {
    var d = el && el.closest ? el.closest("[data-groep]") : null, g = d ? d.dataset.groep : "";
    if (!g) return;
    var kop = { "Content-Type": "application/json", "Accept": "application/json" };
    return fetch((cfg.root || "/") + "cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (c) {
      var sleutels = c.items.filter(function (i) { return groepVan(i) === g; }).map(function (i) { return i.key; }).reverse();
      return sleutels.reduce(function (p, key) {
        return p.then(function () { return fetch((cfg.root || "/") + "cart/change.js", { method: "POST", credentials: "same-origin", headers: kop, body: JSON.stringify({ id: key, quantity: 0 }) }); });
      }, Promise.resolve());
    }).then(function () { delete openBundels[g]; return haalCart(); }).then(function () { if (document.body.classList.contains("template-cart")) location.reload(); })
      .catch(function () { toast("Weghalen lukte niet. Probeer het nog eens."); });
  };
  window.upsellScroll = function (d) { var r = document.getElementById("drawer-upsell-rij"); if (r) r.scrollBy({ left: d * (r.clientWidth * 0.8), behavior: "smooth" }); };
  /* 27 oktober 2026 (Rutger: "als je het winkelkarretje opent moet je niet op de achtergrond kunnen scrollen"): body vastzetten
     zolang een lade open is (overflow:hidden werkt niet op iOS), scrollpositie onthouden en bij sluiten terugzetten. */
  var vastY = 0;
  function vast(aan) {
    var b = document.body;
    if (aan) { if (document.activeElement && document.activeElement.blur) document.activeElement.blur();   /* 28-10: geen blijvende hover/focus-kring op de hamburger (iOS) */
      if (b.classList.contains("vast")) return; vastY = window.pageYOffset || document.documentElement.scrollTop || 0; b.style.top = -vastY + "px"; b.classList.add("vast"); }
    else { if (!b.classList.contains("vast")) return; b.classList.remove("vast"); b.style.top = ""; window.scrollTo(0, vastY); }
  }
  window.cartOpen = function () { document.body.classList.add("cart-open"); vast(true); };
  window.navOpen = function () { document.body.classList.add("nav-open"); vast(true); };
  /* golven: de laag neemt de achtergrondkleur over van wat onderaan de pagina-inhoud zichtbaar
     is, zodat er geen streep ontstaat tussen de laatste sectie en de golven. 3 oktober 2026:
     volgt nu het laatste zichtbare kind zolang dat tot de onderrand loopt (pakte eerst de eerste
     sectie van de pagina, waardoor op Abonnement een zandstrook onder de salie afsluiter stond). */
  (function () {
    var g = document.querySelector(".golven"), m = document.getElementById("inhoud");
    if (!g || !m) return;
    var leeg = function (c) { return !c || c === "transparent" || c === "rgba(0, 0, 0, 0)"; };
    var onder = m.getBoundingClientRect().bottom, el = m, kleur = "";
    while (el) {
      var kids = Array.prototype.filter.call(el.children, function (k) {
        var cs = getComputedStyle(k);
        return !/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(k.tagName) && cs.display !== "none" && cs.position !== "absolute" && cs.position !== "fixed" && k.getBoundingClientRect().height > 0;
      });
      el = kids[kids.length - 1];
      if (!el || Math.abs(el.getBoundingClientRect().bottom - onder) > 2) break;
      var c = getComputedStyle(el).backgroundColor;
      if (!leeg(c)) kleur = c;
    }
    if (kleur) g.style.setProperty("--golf-boven", kleur);
  })();
  /* megamenu: open op binnenkomst, sluit pas 220 ms na het verlaten, zodat een muis
     die recht naar beneden gaat het paneel niet kwijtraakt */
  document.querySelectorAll(".header .nav > ul > li").forEach(function (li) {
    if (!li.querySelector(".megamenu")) return;
    var timer = null;
    li.addEventListener("mouseenter", function () { clearTimeout(timer); li.classList.add("open"); });
    li.addEventListener("mouseleave", function () { timer = setTimeout(function () { li.classList.remove("open"); }, 220); });
  });
  /* zoeken zit in de kop als icoon en klapt een balk eronder open */
  window.zoekToggle = function () {
    var h = document.querySelector(".header");
    if (!h) return;
    var open = h.classList.toggle("zoek-open");
    var knop = h.querySelector(".zoekknop");
    if (knop) knop.setAttribute("aria-expanded", open ? "true" : "false");
    var veld = h.querySelector(".zoekbalk input");
    if (open && veld) setTimeout(function () { veld.focus(); }, 40);
  };
  window.filterOpen = function () { document.body.classList.add("filter-open"); vast(true); };
  window.sluitAlles = function () { document.body.classList.remove("cart-open", "nav-open", "filter-open"); vast(false); };
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") sluitAlles(); });
  haalCart().catch(function () {});

  /* carrousel-pijlen (5 oktober 2026): scrollt per zichtbare kaarten in plaats van een vaste 300px, dimt de pijlen
     aan begin en einde en vult een voortgangsbalk ([data-voortgang="#rij"]) mee met de scrollpositie. */
  (function () {
    var rijen = {};
    function rij(sel) {
      if (!rijen[sel]) { var el = document.querySelector(sel); if (!el) return null; rijen[sel] = { el: el, knoppen: [], balken: [] }; }
      return rijen[sel];
    }
    function stap(r) {
      var k = r.el.querySelector(".kaart") || r.el.firstElementChild;
      if (!k) return 300;
      var b = k.getBoundingClientRect().width + parseFloat(getComputedStyle(r.el).columnGap || getComputedStyle(r.el).gap || 20);
      var zicht = r.el.clientWidth - parseFloat(getComputedStyle(r.el).paddingRight || 0);
      return b * Math.max(1, Math.floor(zicht / b));
    }
    function teken(r) {
      var el = r.el, max = el.scrollWidth - el.clientWidth, x = el.scrollLeft;
      r.knoppen.forEach(function (b) { b.disabled = max <= 1 || (b.dataset.d < 0 ? x <= 1 : x >= max - 1); });
      r.balken.forEach(function (v) {
        var i = v.firstElementChild; if (!i) return;
        var deel = max <= 1 ? 1 : el.clientWidth / el.scrollWidth, breedte = Math.max(12, deel * 100);
        i.style.width = breedte + "%";
        i.style.transform = "translateX(" + (max <= 1 ? 0 : (x / max) * (100 - breedte) / breedte * 100) + "%)";
        v.hidden = max <= 1;
      });
    }
    document.querySelectorAll("[data-scroll]").forEach(function (b) {
      var r = rij(b.dataset.scroll); if (!r) return;
      r.knoppen.push(b);
      b.addEventListener("click", function () { r.el.scrollBy({ left: stap(r) * parseInt(b.dataset.d, 10), behavior: "smooth" }); });
    });
    document.querySelectorAll("[data-voortgang]").forEach(function (v) { var r = rij(v.dataset.voortgang); if (r) r.balken.push(v); });
    Object.keys(rijen).forEach(function (sel) {
      var r = rijen[sel], tik = null;
      function plan() { if (tik) return; tik = requestAnimationFrame(function () { tik = null; teken(r); }); }
      r.el.addEventListener("scroll", plan, { passive: true });
      window.addEventListener("resize", plan);
      if ("ResizeObserver" in window) new ResizeObserver(plan).observe(r.el);
      teken(r);
      window.addEventListener("load", plan);
    });
  })();

  /* ticker (R24) */
  var tk = document.querySelector(".ticker");
  if (tk) {
    var items = tk.querySelectorAll("span"), i = 0;
    if (items.length) items[0].classList.add("aan");
    if (items.length > 1 && !matchMedia("(prefers-reduced-motion: reduce)").matches)
      setInterval(function () { items[i].classList.remove("aan"); i = (i + 1) % items.length; items[i].classList.add("aan"); }, 5000);
  }

  /* USP-strook op mobiel: oneindige loop naar rechts (R18, herzien 6 oktober 2026).
     Elke pil komt van links binnen, staat 5 s precies in het midden en schuift dan naar
     rechts weg; daarna komt de volgende van links. Geen terugspoelen: de baan bestaat uit
     drie kopieën en we verhuizen stil een kopie van achter naar voren zodra de eerste
     kopie in beeld komt. Geen scrollIntoView meer: dat trok de pagina terug naar boven
     terwijl je aan het scrollen was. De baan beweegt met transform, de pagina niet. */
  var uspWrap = document.querySelector(".usps .wrap");
  if (uspWrap && uspWrap.children.length > 1 && matchMedia("(max-width:720px)").matches && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
    (function () {
      var STIL = 5000, SCHUIF = 900;
      /* omgekeerde volgorde: bij beweging naar rechts komt de volgende pil van links,
         zo blijft de leesvolgorde (1, 2, 3, 4) in de tijd behouden */
      var origineel = Array.prototype.slice.call(uspWrap.children).reverse(), n = origineel.length;
      var baan = document.createElement("div"); baan.className = "usp-baan";
      for (var k = 0; k < 3; k++) origineel.forEach(function (el) { baan.appendChild(k === 1 ? el : el.cloneNode(true)); });
      /* de lay-out staat ook in petsnack.css (.usps.loopt), maar hier inline als vangnet: zonder deze regels
         staan de twaalf pillen onder elkaar (gezien op 6 oktober 2026 toen de CSS even zonder dat blok live stond) */
      var TRANS = "transform .9s cubic-bezier(.45,0,.2,1)";
      baan.style.cssText = "position:relative;display:flex;gap:10px;width:max-content;will-change:transform;transition:" + TRANS;
      uspWrap.style.cssText += ";display:block;overflow:hidden;padding:10px 0;scroll-snap-type:none";
      uspWrap.appendChild(baan);
      uspWrap.parentNode.classList.add("loopt");
      var i = 2 * n - 1; /* eerste pil van de middelste kopie staat eerst in het midden */
      function midden(idx) {
        var pil = baan.children[idx];
        return uspWrap.clientWidth / 2 - (pil.offsetLeft + pil.offsetWidth / 2);
      }
      function zet(idx, direct) {
        if (direct) baan.style.transition = "none";
        baan.style.transform = "translate3d(" + midden(idx).toFixed(1) + "px,0,0)";
        if (direct) { void baan.offsetWidth; baan.style.transition = TRANS; }
      }
      zet(i, true);
      function stap() {
        i -= 1; zet(i, false);
        setTimeout(function () {
          if (i < n) { /* eerste kopie bereikt: laatste kopie stil naar voren, zelfde beeld */
            for (var m = 0; m < n; m++) baan.insertBefore(baan.lastElementChild, baan.firstElementChild);
            i += n; zet(i, true);
          }
          setTimeout(stap, STIL);
        }, SCHUIF);
      }
      setTimeout(stap, STIL);
      var rs; window.addEventListener("resize", function () { clearTimeout(rs); rs = setTimeout(function () { zet(i, true); }, 120); });
    })();
  }

  /* footer-accordion (R16) */
  document.querySelectorAll(".footer .kolom h4").forEach(function (h) { h.addEventListener("click", function () { if (matchMedia("(max-width:820px)").matches) h.parentNode.classList.toggle("open"); }); });

  /* ---------- collectiepagina: filters ----------
     De zijbalk is de waarheid. De drawer (mobiel) kopieert zijn vinkjes bij "Toon"
     naar de zijbalk; chips boven het grid en "Wis alles" zetten beide. */
  var grid = document.getElementById("productgrid");
  if (grid) {
    var kaartenAlle = Array.prototype.slice.call(grid.querySelectorAll(".kaart"));
    var teller = document.getElementById("teller"), knopTeller = document.getElementById("filter-teller"), badge = document.getElementById("filter-badge");
    var zijbalk = document.querySelector(".filters.zijbalk"), drawer = document.querySelector(".filterdrawer"), sorteer = document.querySelector(".sorteer select"), actiefLijst = document.getElementById("actief-filters");
    var KD = { kort: "Snel op", middel: "Even zoet", lang: "Lang kauwen" };
    function actief(bron) {
      var f = { dier: [], kauwduur: [], sort: "populair" };
      if (bron) bron.querySelectorAll("input[type=checkbox]:checked").forEach(function (c) { if (f[c.name]) f[c.name].push(c.value); });
      var s = (bron && bron.querySelector("input[name=sort]:checked")) || sorteer; if (s) f.sort = s.value;
      return f;
    }
    function past(k, f) {
      var d = k.dataset;
      return (!f.dier.length || (d.dier || "").split("|").some(function (x) { return f.dier.indexOf(x) >= 0; })) && (!f.kauwduur.length || f.kauwduur.indexOf(d.kauwduur) >= 0);
    }
    function prijs(k) { var p = parseFloat(k.dataset.prijs); return p > 0 ? p : Infinity; }
    function chip(naam, waarde, tekst) {
      var b = document.createElement("button"); b.type = "button"; b.textContent = tekst; b.setAttribute("aria-label", tekst + " weghalen");
      b.addEventListener("click", function () { zet(naam, waarde, false); pasToe(); });
      return b;
    }
    function zet(naam, waarde, aan) { document.querySelectorAll(".filters input[name='" + naam + "'][value='" + waarde.replace(/'/g, "\\'") + "']").forEach(function (c) { c.checked = aan; }); }
    function wis() { document.querySelectorAll(".filters input[type=checkbox]").forEach(function (c) { c.checked = false; }); pasToe(); }
    function pasToe() {
      var f = actief(zijbalk), zicht = kaartenAlle.filter(function (k) { return past(k, f); });
      zicht.sort(function (a, b) {
        /* Standaard (Populair) staan de snackbundels bovenaan, in de volgorde van de collectie (Rutger 01-10: "die verkoop je het liefst"). */
        if (f.sort === "populair" && a.dataset.bundel !== b.dataset.bundel) return (b.dataset.bundel === "1") - (a.dataset.bundel === "1");
        if (f.sort === "prijs-op") return prijs(a) - prijs(b);
        if (f.sort === "prijs-af") return b.dataset.prijs - a.dataset.prijs;
        if (f.sort === "naam") return a.dataset.naam.localeCompare(b.dataset.naam, "nl");
        return b.dataset.reviews - a.dataset.reviews;
      });
      kaartenAlle.forEach(function (k) { k.hidden = true; });
      zicht.forEach(function (k) { k.hidden = false; grid.appendChild(k); });
      var g = grid.querySelector(".geenres"); if (g) g.remove();
      if (!zicht.length) {
        g = document.createElement("div"); g.className = "geenres"; g.textContent = "Geen snacks binnen deze filters.";
        var w = document.createElement("button"); w.type = "button"; w.className = "wis"; w.textContent = "Wis de filters"; w.addEventListener("click", wis); g.appendChild(w); grid.appendChild(g);
      }
      if (teller) teller.textContent = zicht.length + " snack" + (zicht.length === 1 ? "" : "s");
      var n = f.dier.length + f.kauwduur.length;
      document.querySelectorAll(".filterkop [data-wis]").forEach(function (w) { w.hidden = !n; });
      if (badge) { badge.hidden = !n; badge.textContent = n; }
      if (actiefLijst) {
        actiefLijst.innerHTML = ""; actiefLijst.hidden = !n;
        f.kauwduur.forEach(function (v) { actiefLijst.appendChild(chip("kauwduur", v, KD[v] || v)); });
        f.dier.forEach(function (v) { actiefLijst.appendChild(chip("dier", v, v)); });
      }
      telDrawer();
    }
    function telDrawer() {
      if (!drawer) return;
      var f = actief(drawer), n = kaartenAlle.filter(function (k) { return past(k, f); }).length;
      if (knopTeller) knopTeller.textContent = "Toon " + n + " snack" + (n === 1 ? "" : "s");
    }
    if (zijbalk) zijbalk.addEventListener("input", pasToe);
    if (sorteer) sorteer.addEventListener("change", pasToe);
    if (drawer) {
      drawer.addEventListener("input", telDrawer);
      var toon = document.getElementById("filter-toepassen");
      if (toon) toon.addEventListener("click", function () {
        if (zijbalk) zijbalk.querySelectorAll("input[type=checkbox]").forEach(function (c) { var d = drawer.querySelector("input[name='" + c.name + "'][value='" + c.value.replace(/'/g, "\\'") + "']"); if (d) c.checked = d.checked; });
        var r = drawer.querySelector("input[name=sort]:checked"); if (r && sorteer) sorteer.value = r.value;
        pasToe(); sluitAlles();
      });
    }
    document.querySelectorAll("[data-wis]").forEach(function (w) { w.addEventListener("click", wis); });
    document.querySelectorAll("[data-meer]").forEach(function (b) {
      b.addEventListener("click", function () {
        var box = b.previousElementSibling; if (!box) return;
        box.hidden = !box.hidden; b.setAttribute("aria-expanded", box.hidden ? "false" : "true"); b.textContent = box.hidden ? b.dataset.dicht : b.dataset.open;
      });
    });
    pasToe();
  }

  /* ---------- PDP (koopblok naar Karperloco, 30-09-2026) ---------- */
  var koop = document.querySelector(".koop");
  if (koop) {
    var form = document.getElementById("koopform"), idEl = document.getElementById("variant-id"), knop = koop.querySelector("[data-pdp-koop]");
    var tegels = koop.querySelectorAll(".tegel input"), aantal = koop.querySelector(".stepper input"), stepper = koop.querySelector(".stepper");
    var d1 = parseFloat(koop.dataset.drempel1 || 0), k1 = parseFloat(koop.dataset.korting1 || 0);
    var d2 = parseFloat(koop.dataset.drempel2 || 0), k2 = parseFloat(koop.dataset.korting2 || 0);
    var eenh = koop.dataset.eenheid || "zak", eenhmv = koop.dataset.eenheidMv || "zakken";
    var zakken = function (n) { return n + " " + (n === 1 ? eenh : eenhmv); };
    var gekozen = function () { return koop.querySelector(".tegel input:checked"); };
    /* abonnement (selling plan): gekozen plan en de abo-prijs van de huidige variant */
    var aboKeuze = koop.querySelector("input[name=koopoptie][value=abo]"), aboPlan = koop.querySelector("[data-abo-plan]");
    var planGekozen = function () { return aboKeuze && aboKeuze.checked && aboPlan ? aboPlan.value : ""; };
    var aboPrijs = function (t, per) {
      if (!aboPlan) return 0;
      var map = {}; try { map = JSON.parse((t || koop).dataset.abo || "{}"); } catch (e) {}
      return map[aboPlan.value] || 0;
    };
    var reken = function () {
      var t = gekozen();
      var per = t ? parseInt(t.dataset.prijs, 10) : parseInt(koop.dataset.prijs, 10);
      var vgl = t ? parseInt(t.dataset.vergelijk || 0, 10) : parseInt(koop.dataset.vergelijk || 0, 10);
      var ap = aboPrijs(t, per);
      var pe = koop.querySelector("[data-abo-eenmalig]"), pa = koop.querySelector("[data-abo-prijs]"), pl = koop.querySelector("[data-abo-los]");
      if (pe) pe.textContent = euro(per);
      if (pa && ap) pa.textContent = euro(ap);
      if (pl) pl.textContent = euro(per);
      if (planGekozen() && ap) { vgl = per; per = ap; }
      var titel = t ? t.dataset.titel : (koop.dataset.titel || "");
      var n = Math.max(1, parseInt((aantal && aantal.value) || 1, 10));
      var bruto = n * per / 100;
      var factor = 1;
      if (d1 > 0 && k1 > 0) factor = (d2 > d1 && k2 > k1 && bruto >= d2 - 0.005) ? 1 - k2 / 100 : (bruto >= d1 - 0.005 ? 1 - k1 / 100 : 1);
      var perK = Math.round(per * factor), totaal = n * perK, basis = n * per;
      var tot = koop.querySelector("[data-totaal]"); if (tot) tot.textContent = euro(totaal);
      var ds = koop.querySelector("[data-vergelijk]");
      if (ds) { if (vgl > per) { ds.hidden = false; ds.textContent = euro(vgl * n); } else ds.hidden = true; }
      var prl = koop.querySelector("[data-prijsregel]");
      if (prl) prl.textContent = n === 1 ? "per " + eenh + (titel ? " van " + titel : "") + ", incl. btw" : n + " " + eenhmv + ", " + euro(perK) + " per " + eenh + ", incl. btw";
      var bes = koop.querySelector("[data-bespaar]");
      if (bes) {
        var tekst = "";
        /* 28 oktober 2026 (Rutger: ", je bespaart" zag er raar uit): als chip met percentage, zoals in de bundelkaart */
        if (basis - totaal > 0) tekst = '<span class="chip">−' + Math.round((basis - totaal) / basis * 100) + '%</span> Je bespaart ' + euro(basis - totaal);
        else if (vgl > per) tekst = '<span class="chip">−' + Math.round((vgl - per) / vgl * 100) + '%</span> Je bespaart ' + euro((vgl - per) * n);
        bes.innerHTML = tekst; bes.hidden = !tekst;
      }
      var kt = koop.querySelector("[data-kortingtekst]");
      if (kt && d1 > 0 && k1 > 0) {
        var tweede = d2 > d1 && k2 > k1;
        var nog1 = Math.max(1, Math.ceil((d1 - bruto) / (per / 100) - 0.0001)), nog2 = Math.max(1, Math.ceil((d2 - bruto) / (per / 100) - 0.0001));
        if (tweede && bruto >= d2 - 0.005) kt.textContent = k2 + "% korting, de meeste korting";
        else if (bruto >= d1 - 0.005) kt.textContent = tweede ? k1 + "% korting, nog " + zakken(nog2) + " tot " + k2 + "%" : k1 + "% korting op je bestelling";
        else kt.textContent = "Nog " + zakken(nog1) + " tot " + k1 + "% korting";
      }
      /* spaarladder onder de knop (8 oktober 2026): dezelfde tredes en balk als de mand, bedrag =
         wat al in de mand ligt (zonder cadeaus) plus dit product maal het aantal */
      var spaar = document.querySelector("[data-spaar]");
      if (spaar) {
        var sl = document.getElementById("drawer-ladder"), st = sl ? tredes(sl) : [];
        if (st.length) { spaar.innerHTML = ladder(st, mandSub + bruto); spaar.hidden = false; } else spaar.hidden = true;
      }
      var sp = document.querySelector(".koopbalk [data-sticky-prijs]"); if (sp) sp.textContent = euro(totaal);
      if (idEl && t) idEl.value = t.dataset.variant;
      if (knop && t) { knop.disabled = false; knop.textContent = "In winkelmand"; }
    };
    pdpReken = reken;
    tegels.forEach(function (t) { t.addEventListener("change", reken); });
    if (stepper) stepper.querySelectorAll("button").forEach(function (b) { b.addEventListener("click", function () { aantal.value = Math.max(1, (parseInt(aantal.value, 10) || 1) + (b.dataset.d === "-" ? -1 : 1)); reken(); }); });
    if (aantal) aantal.addEventListener("change", reken);
    if (form) form.addEventListener("submit", function (e) { e.preventDefault(); cartAdd(idEl.value, Math.max(1, parseInt(aantal.value, 10) || 1), planGekozen()); });
    koop.querySelectorAll("input[name=koopoptie]").forEach(function (r) { r.addEventListener("change", reken); });
    if (aboPlan) aboPlan.addEventListener("change", reken);
    koop.querySelectorAll(".kort button").forEach(function (b) { b.addEventListener("click", function () { var k = b.closest(".kort"); var open = k.classList.toggle("open"); b.textContent = open ? "Lees minder" : "Lees meer"; }); });
    var thumbs = document.querySelectorAll(".galerij .thumbs button"), groot = document.getElementById("galerij-groot");
    thumbs.forEach(function (t) { t.addEventListener("click", function () { thumbs.forEach(function (x) { x.classList.remove("actief"); }); t.classList.add("actief"); if (groot) groot.src = t.dataset.groot; }); });
    /* mobiel: sticky koopbalk zodra de bestelrij uit beeld is */
    var balk = document.querySelector(".koopbalk"), bestelrij = koop.querySelector(".bestelrij");
    if (balk && bestelrij) {
      /* 28 oktober 2026 (Rutger: "hij zweeft nog steeds"): niet meer position:fixed op body (iOS laat zo'n balk hangen als de Safari-balk
         inklapt), maar position:sticky als laatste kind van <main>. Sticky plakt aan de zichtbare onderrand en stopt vanzelf bij de
         bovenkant van de footer. Zichtbaar zodra de bestelrij uit beeld is. Stijl: blok "koopbalk sticky" in petsnack.css. */
      var hoofd = document.getElementById("inhoud") || document.querySelector("main") || document.body;
      hoofd.appendChild(balk);
      var sk = balk.querySelector("[data-sticky-koop]");
      if (sk) sk.addEventListener("click", function () { if (form) { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event("submit", { cancelable: true })); } });
      var check = function () { var toon = bestelrij.getBoundingClientRect().bottom < 0; balk.hidden = !toon; balk.classList.toggle("zichtbaar", toon); };
      window.addEventListener("scroll", check, { passive: true }); window.addEventListener("resize", check); check();
    }
    reken();
  }
})();

/* ---------------------------------------------------------------- bolletjes onder horizontale rijen (6 oktober 2026)
   Rutger: "zet van die bolletjes neer aan de onderkant zodat iemand ziet dat hij kan scrollen". Elke rij die
   horizontaal scrolt krijgt een rij bolletjes eronder: één per scrollpositie (per kaart op mobiel, per schermvulling
   op desktop), het actieve bolletje is een streepje. Verschijnt alleen als de rij echt breder is dan het scherm,
   dus op desktop-rasters (stappen, stories, kauwmeter) blijft hij weg. Tikken op een bolletje scrolt ernaartoe.
   Rijen: .carrousel, reviews, trust, stories, stappen, kauwmeter en alles met data-bolletjes. Met
   data-bolletjes-doel="#id" komen de bolletjes in dat element in plaats van direct onder de rij.
   Terugzetten: backup/mobiel-bolletjes-20261006/. */
(function () {
  var SEL = ".carrousel, .reviews .rij, .trust .rij, .stories .rij, .stappen, .km-stations, .naast, .pr-lijst, [data-bolletjes]";
  function maak(el) {
    if (el._bolletjes) return;
    var nav = document.createElement("div"); nav.className = "bolletjes"; nav.setAttribute("aria-hidden", "true"); nav.hidden = true;
    var doel = el.getAttribute("data-bolletjes-doel") ? document.querySelector(el.getAttribute("data-bolletjes-doel")) : null;
    if (doel) doel.insertBefore(nav, doel.firstChild); else el.parentNode.insertBefore(nav, el.nextSibling);
    el._bolletjes = nav;
    var posities = [], knoppen = [];
    function meet() {
      var max = el.scrollWidth - el.clientWidth;
      if (max <= 4) { nav.hidden = true; return; }
      var cs = getComputedStyle(el), pl = parseFloat(cs.paddingLeft) || 0;
      var links = el.getBoundingClientRect().left + pl - el.scrollLeft, lijst = [];
      Array.prototype.forEach.call(el.children, function (k) {
        if (k.hidden || getComputedStyle(k).display === "none") return;
        var x = Math.round(Math.min(Math.max(0, k.getBoundingClientRect().left - links), max));
        if (!lijst.length || x - lijst[lijst.length - 1] > 6) lijst.push(x);
      });
      posities = lijst;
      if (posities.length < 2) { nav.hidden = true; return; }
      if (knoppen.length !== posities.length) {
        nav.innerHTML = ""; knoppen = [];
        posities.forEach(function (p, i) {
          var b = document.createElement("button"); b.type = "button"; b.tabIndex = -1;
          b.addEventListener("click", function () { el.scrollTo({ left: posities[i], behavior: "smooth" }); });
          nav.appendChild(b); knoppen.push(b);
        });
      }
      nav.hidden = false;
      teken();
    }
    function teken() {
      if (!posities.length) return;
      var x = el.scrollLeft, best = 0;
      posities.forEach(function (p, i) { if (Math.abs(p - x) < Math.abs(posities[best] - x)) best = i; });
      knoppen.forEach(function (b, i) { b.classList.toggle("aan", i === best); });
    }
    var tik = null;
    function plan() { if (tik) return; tik = requestAnimationFrame(function () { tik = null; meet(); }); }
    el.addEventListener("scroll", function () { if (tik) return; tik = requestAnimationFrame(function () { tik = null; teken(); }); }, { passive: true });
    window.addEventListener("resize", plan);
    window.addEventListener("load", plan);
    if ("ResizeObserver" in window) { var ro = new ResizeObserver(plan); ro.observe(el); Array.prototype.forEach.call(el.children, function (k) { ro.observe(k); }); }
    if ("MutationObserver" in window) new MutationObserver(plan).observe(el, { childList: true, attributes: true, attributeFilter: ["hidden", "class"], subtree: false });
    meet();
  }
  function alles() { document.querySelectorAll(SEL).forEach(maak); }
  window.bolletjes = maak;
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", alles); else alles();
})();
